export { NextIconComponent } from './next/next.component';
export { PrevComponent } from './prev/prev.component'
export { XdIconComponent } from './xd/xd.component'